import { createMetadata } from '../../utils/models';
import {
  // METADATA_TYPE_METADATA,
  METADATA_TYPE_ADSWIZZ_AD,
  METADATA_TYPE_NOWPLAYING
} from '../../constants';
import { url_query_set } from '../../../utils/url';
import Timeline from '../../controllers/timeline';

const RXP = ',?([^ ]+)=("([^"]+)"|([^ ]+))';
const ACTION_CLEAR = 'CLEAR';
const ACTION_AD_STOP = 'AD_STOP';
const ACTION_AD_START = 'AD_START';
const AD_SLOT_PRE = 'preroll';
// const AD_SLOT_MID = 'midroll';
const AD_SLOT_POST = 'postroll';

export default class AdswizzMetadataParser {
  static get defaultOptions () {
    return {
      afrUrl: '',
      zoneAlias: 'DisplayZone'
    };
  }

  constructor (options) {
    options = Object.assign({}, AdswizzMetadataParser.defaultOptions, options);

    this._afrUrl = options.afrUrl;
    this._zoneAlias = null;
    if (options.zoneAlias) {
      this._zoneAlias = Array.isArray(options.zoneAlias) ? options.zoneAlias : [options.zoneAlias];
    }
  }

  /**
   * Update the GDPR settign used when building AFR urls
   *
   * @param {boolean|object} gdpr
   */
  setGDPR (gdpr) {
    let afrUrl = this._afrUrl;
    if (gdpr === true) {
      afrUrl = url_query_set(afrUrl, 'aw_0_req.gdpr', 'true');
    } else if (gdpr && gdpr.userConsent) {
      afrUrl = url_query_set(afrUrl, 'aw_0_req.userConsent', gdpr.userConsent);
    }
    this._afrUrl = afrUrl;
  }

  /**
   * Parses metadata from an AdsWizz metadata response
   *
   * @param {string} str Raw metadata response text
   * @return {object[]}
   */
  parse (str) {
    const result = [];
    const lines = str.split('\n');

    let startTime;
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim();

      if (line.match(/^[0-9]+$/)) {
        startTime = Number(line);
      } else {
        const lineData = this.parseLine(line);

        switch (lineData) {
          case ACTION_CLEAR:
            result.push({
              action: Timeline.ACTION_CLEAR,
              startTime: startTime / 1000
            });
            break;
          case ACTION_AD_STOP:
            result.push({
              action: Timeline.ACTION_AD_STOP,
              startTime: startTime / 1000
            });
            break;
          case ACTION_AD_START:
            result.push({
              action: Timeline.ACTION_AD_START,
              startTime: startTime / 1000
            });
            break;
          default:
            result.push(this.createMetadata(startTime, lineData));
            break;
        }
      }
    }

    return result;
  }

  /**
   * Parses metadata from a single line of an AdsWizz metadata response
   *
   * @param  {string} line A single metadata line
   * @return {object}
   */
  parseLine (line) {
    if (line === '' || line === ACTION_CLEAR) {
      return Timeline.ACTION_CLEAR;
    }

    if (line === ACTION_AD_STOP) {
      return Timeline.ACTION_AD_STOP;
    }

    if (line === ACTION_AD_START) {
      return Timeline.ACTION_AD_START;
    }

    const result = {};
    const rxp = new RegExp(RXP, 'g');

    let match = rxp.exec(line);
    do {
      result[match[1]] = (match[4] || match[3]).trim();
      match = rxp.exec(line);
    } while (match);

    if (result.title === ACTION_AD_STOP) {
      return Timeline.ACTION_AD_STOP;
    }

    if (result.title === ACTION_AD_START) {
      return Timeline.ACTION_AD_START;
    }

    return result;
  }

  /**
   * Create a metadata entry from parsed AdsWizz metadata
   *
   * @param  {number} startTime The start time of this metadata entry
   * @param  {object} metadata  The metadata for this entry
   * @return {object}
   */
  createMetadata (startTime, metadata) {
    const result = {
      startTime: startTime / 1000
    };

    if (metadata.adw_ad) {
      const ad = {
        position: result.startTime,
        slot: 'mid',
        metadata: createMetadata({
          contentType: METADATA_TYPE_ADSWIZZ_AD,
          uid: metadata.adId
        }),
        companions: []
      };

      if (metadata.durationMilliseconds) {
        ad.metadata.duration = Number(metadata.durationMilliseconds) / 1000;
      }

      if (metadata.insertionType === AD_SLOT_PRE) {
        ad.slot = 'pre';
      } else if (metadata.insertionType === AD_SLOT_POST) {
        ad.slot = 'post';
      }

      if (this._afrUrl && this._zoneAlias && metadata.adswizzContext) {
        this._zoneAlias.forEach(zoneAlias => {
          let afrUrl = this._afrUrl;

          afrUrl = url_query_set(afrUrl, 'zone_alias', zoneAlias);
          afrUrl = url_query_set(afrUrl, 'context', metadata.adswizzContext);
          afrUrl = url_query_set(afrUrl, 'cb', Date.now());

          ad.companions.push({
            type: 'iframe',
            url: afrUrl,
            zoneAlias: zoneAlias
          });
        });
      }

      result.action = Timeline.ACTION_AD_START;
      result.ad = ad;
    } else {
      // metadata.contentType = METADATA_TYPE_METADATA;
      metadata.contentType = METADATA_TYPE_NOWPLAYING;
      if (metadata.durationMilliseconds) {
        metadata.duration = Number(metadata.durationMilliseconds) / 1000;
        delete result.metadata.durationMilliseconds;
      }
      result.metadata = createMetadata(metadata);
    }

    return result;
  }
}
